import React, {FC, useState} from 'react';
import {NewsPostProps} from './TYPE_NewsPost';
import {isMasterFirebaseUser} from '../../../library/GeneralUse';
import {NewsPostFooter} from './NewsPostFooter';

const style = {
	container: `flex flex-col gap-y-2   p-4   text-whirlwindLightest   bg-whirlwindDarkest   divide-y-4 divide-whirlwindDark   rounded-md   opacity-90`,
	editingPost: `p-2   min-h-40 max-h-60   text-whirlwindDarkest   bg-whirlwindLightest`,
	editingPostTitle: `flex basis-2/3 justify-start   p-2   text-whirlwindDarkest   bg-whirlwindLightest`,
	header: `flex flex-row items-center`,
	post: `pt-1   break-words`,
	time: `text-xs text-right`,
	title: `flex basis-2/3 justify-start   text-lg font-semibold`,
	username: `flex basis-1/3 justify-end   text-lg font-semibold text-whirlwindPrimaryLight`,
};

export const NewsPost: FC<NewsPostProps> = ({
	content,
	created_at,
	dataTestContent,
	dataTestTitle,
	documentId,
	last_edited_at,
	title,
	uid,
	username,
	currentlyEditingDocumentId,
	setCurrentlyEditingDocumentId,
}) => {
	// Component variables
	const [currentlyEditing, setCurrentlyEditing] = useState(false);

	return (
		<div
			className={style.container}
			data-test-content={dataTestContent}
			data-test-title={dataTestTitle}>
			<div className={style.header}>
				{currentlyEditing ? (
					<input
						className={style.editingPostTitle}
						data-test-id={`${documentId}_NewsPostTitleEditing_TEST`}
						defaultValue={title}
						id={`${documentId}_NewsPostTitleEditing`}
						maxLength={50}
						minLength={1}
					/>
				) : (
					<span className={style.title}>{title}</span>
				)}
				<span className={style.username}>
					{isMasterFirebaseUser(uid) ? username : '???'}
				</span>
			</div>
			{currentlyEditing ? (
				<textarea
					className={style.editingPost}
					data-test-id={`${documentId}_NewsPostEditing_TEST`}
					defaultValue={content}
					id={`${documentId}_NewsPostEditing`}
					maxLength={500}
					minLength={1}
				/>
			) : (
				<div className={style.post}>
					<span>{content}</span>
				</div>
			)}
			<NewsPostFooter
				created_at={created_at}
				documentId={documentId}
				last_edited_at={last_edited_at}
				currentlyEditing={currentlyEditing}
				setCurrentlyEditing={setCurrentlyEditing}
				currentlyEditingDocumentId={currentlyEditingDocumentId}
				setCurrentlyEditingDocumentId={setCurrentlyEditingDocumentId}
			/>
		</div>
	);
};
